import {APP_URLS} from "./urls";
import {lazy} from "react";

const MainPage = lazy(() => import ("./Components/MainPage"));
const Transactions = lazy(() => import ("./Components/Transactions"));
const Referrals = lazy(() => import ("./Components/Referrals"));
const LeaderBoard = lazy(() => import ("./Components/LeaderBoard"));
const Hardware = lazy(() => import ("./Components/Hardware"));
const Profile = lazy(() => import ("./Components/Profile"));
const ConfirmEmail = lazy(() => import ("./Components/Profile/ConfirmEmail"));

export const routes = [
    {path: APP_URLS.routes.main, index: true, exact: true, name: 'Main', component: MainPage},
    {path: APP_URLS.routes.transactions, exact: true, name: 'Transactions', component: Transactions},
    {path: APP_URLS.routes.referrals, exact: true, name: 'Referrals', component: Referrals},
    {path: APP_URLS.routes.leader_board, exact: true, name: 'Leader Board', component: LeaderBoard},
    {path: APP_URLS.routes.hardware, exact: true, name: 'Hardware', component: Hardware},
    {path: APP_URLS.routes.profile, exact: true, name: 'Profile', component: Profile}
];


export const service_routes = [
    {path: APP_URLS.routes.confirmEmail + '/:uid?/:token?', service: true, exact: true, name: 'Confirm Email', component: ConfirmEmail}
]
